module.exports = __webpack_public_path__ + "static/media/gcdef_10050.8d2701fa.ico";